import { UniversityStudyRoomTemplate } from "@/components/UniversityStudyRoomTemplate";

const UniversityOfWaterloo = () => {
  return (
    <UniversityStudyRoomTemplate
      universityName="University of Waterloo"
      universityShortName="Waterloo"
      slug="university-of-waterloo"
      seoTitle="University of Waterloo Study Rooms | Campus Library Study Guide"
      seoDescription="Complete guide to study rooms at University of Waterloo. Find Dana Porter, Davis Centre, and SLC study spaces. Plus free 24/7 online alternative."
      seoKeywords="waterloo study rooms, university of waterloo library, dana porter library, davis centre, slc study rooms, uwaterloo study spaces"
      canonicalUrl="/study-room/university-of-waterloo/"
      heroDescription="A comprehensive guide to study rooms at Waterloo, including Dana Porter Library, Davis Centre, and the Student Life Centre."
      libraryWebsiteUrl="https://uwaterloo.ca/library/"
      libraryWebsiteName="Waterloo Library"
      studySpaces={[
        {
          name: "Dana Porter Library - Study Rooms",
          features: "Group and single-study rooms with a three-hour booking limit. Students allowed three bookings per week.",
          feedback: "Single study rooms are in high demand during exams; 15-minute no-show rule applies."
        },
        {
          name: "Davis Centre Library - Study Rooms",
          features: "Similar to Dana Porter with group and individual rooms; three-hour limit per booking.",
          feedback: "Popular with engineering and math students; fills quickly during midterms."
        },
        {
          name: "Single Study Rooms",
          features: "Seat up to two people for focused individual or pair work.",
          feedback: "High demand during exams; no-show rule releases room after 15 minutes."
        },
        {
          name: "Student Life Centre (SLC) - Private Study Rooms",
          features: "19 private study rooms for 4-16 people. Bookings require visiting the Turnkey Desk and leaving Watcard as collateral.",
          feedback: "Variety of room sizes available but manual booking process; strict rules (no dance practice, one booking per day)."
        }
      ]}
      guideContent={
        <>
          <p className="mb-4">
            Use library rooms for quiet individual work and the <strong>SLC for large group projects</strong>. Bring your Watcard and plan ahead; rooms are snapped up quickly.
          </p>
          <p className="mb-4">
            Avoid no-shows—missing your booking <strong>three times will get you barred</strong> from the system. The SLC requires leaving your Watcard as collateral.
          </p>
          <p>
            Students appreciate the SLC's variety of room sizes but complain about the manual booking process.
          </p>
        </>
      }
      summaryTips={[
        "Plan bookings ahead: Only three bookings per week allowed at library rooms.",
        "Arrive on time: 15-minute no-show rule releases your booking to others.",
        "Use SLC for large groups: 19 rooms accommodate 4-16 people each.",
        "Bring your Watcard: Required as collateral for SLC room bookings.",
        "Use CSW for unlimited access: No booking limits or Watcard requirements."
      ]}
    />
  );
};

export default UniversityOfWaterloo;
